import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import _, { filter, map, flatten, isArray ,find,extend,pick} from "lodash";
import moment from "moment";
import { callApi, callApiIO } from "../../api";
// eslint-disable-next-line import/no-cycle
import { useAuth } from "../useAuth";
import {
  formatProductCategories,
  formatServiceCategories,
  formatServiceCategoriesAll,
  parseJSON,
} from "../../utility/CustomFunction";

import DuckDb from "../../utility/DuckDb";

export default () => {
  const {
    selectedBusiness,
    isAdmin,
    admin,
    business: businessList,
    user,
    runWithGuard,
    updateCurrentBusiness,
    logOut,
  } = useAuth();

  const business =
    admin?.businesses || businessList?.map((el) => el.business) || [];
  const [businessPayrollInfo, setBusinessPayrollInfo] = useState(null);
  const [businessPayrollInfoData, setBusinessPayrollInfoData] = useState(null);
  const [
    businessPayrollWithServiceDetail,
    setBusinessPayrollWithServiceDetail,
  ] = useState(null);
  const [taskResourceMap, setTaskResourceMap] = useState(null);
  const [businessPeriodReport, setBusinessPeriodReport] = useState(null);
  const [staffVisitReport, setStaffVisitReport] = useState(null);
  const [businessInfo, setBusinessInfo] = useState(null);
  const [businessInventory, setBusinessInventory] = useState(null);
  const [unfilteredProducts, setUnfilteredProducts] = useState(null);
  const [businessServices, setBusinessServices] = useState(null);
  const [businessMemberships, setBusinessMemberships] = useState(null);
  const [businessAllServices, setBusinessAllServices] = useState(null);
  const [unfilteredServices, setUnfilteredServices] = useState(null);
  const [allFilteredServices, setAllFilteredServices] = useState(null);
  const [businessLocations, setBusinessLocations] = useState([]);
  const [businessEligibleLocations, setBusinessEligibleLocations] = useState(
    []
  );
  const [businessProducts, setBusinessProducts] = useState(null);
  const [businessAllProducts, setbusinessAllProducts] = useState(null);

  const [serviceKinds, setServiceKinds] = useState(null);

  const [businessAllLocationServices, setBusinessAllLocationServices] =
    useState(null);
  const [businessPrepaid, setBusinessPrepaid] = useState(null);
  const [businessPrepaidCata, setBusinessPrepaidCata] = useState(null);
  const [businessTablePreference, setBusinessTablePreference] = useState({});
  const [visitReportTableSettings, setVisitReportTableSettings] =
    useState(null);
  const [businessSettings, setBusinessSettings] = useState(null);
  const [businessLoading, setBusinessLoading] = useState(false);
  const [membershipCategoryID, setMembershipCategoryID] = useState();
  // const [customerSearchHistory, setCustomerSearchHistory] = useState(null);
  const [customerSearchParams, setCustomerSearchParams] = useState(null);

  const [customReports, setCustomReports] = useState();
  const [pivotReports, setPivotReports] = useState();
  const [allLocationCampaigns, setAllLocationCampaigns] = useState();

  const [pastDueBusinessInvoices, setPastDueBusinessInvoices] = useState([]);
  const [pastDueUserInvoices, setPastDueUserInvoices] = useState([]);

  const [dbInstance, setDbInstance] = useState(null);

  // UPDATED: Add Cube.js specific states
  const [cubeBusinessPeriodReport, setCubeBusinessPeriodReport] =
    useState(null);
  const [cubeBusinessLoading, setCubeBusinessLoading] = useState(false);
  // Granularity the backend rolled the period report up to ("day" or "month").
  const [cubeGranularity, setCubeGranularity] = useState("day");
  const [sampleQuestions, setSampleQuestions] = useState(null);

  // const customerSearchTableId = "customer-search-filters";
  const visitReportTableId = "visit-report-preferences";
  const [localHours, setLocalHours] = useState({});
  const [enforceEnable, setEnforceEnable] = useState(false);

  const fetchMCPSamplequestions = async () => {
    if (sampleQuestions === null) {
      const sysQuestionsRes = await callApi(
        `/protected/business/${
          selectedBusiness?.id
        }/iorequest?dest=${encodeURIComponent(
          `business/:BID:/systemsettings/uzeli-settings-mcp-sample-questions`
        )}`
      );
      if (sysQuestionsRes?.success) {
        const sampleQue = parseJSON(sysQuestionsRes?.data[0]?.configurations);
        /* eslint-disable no-console */
        // console.log("Fetched MCP Sample Questions:", sampleQue);
        if (sampleQue) setSampleQuestions(sampleQue);
      }
    }
  };

  const getBusinessUnpaidInvoices = async () => {
    try {
      const res = await callApi(
        `/protected/business/${
          selectedBusiness.id
        }/billing?dest=${encodeURIComponent(
          `api/invoice/:BID:/business-unpaid-invoices`
        )}`
      );
      const filters = {
        status: ["unpaid"],
        hidedeleted: true,
      };
      const res2 = await callApi(
        `/protected/business/${
          selectedBusiness?.id
        }/billing?dest=${encodeURIComponent(
          `api/invoice/:UID:/withfilter${
            filters ? `?s=${JSON.stringify(filters)}` : ""
          }`
        )}`
      );
      if (res?.success) {
        setPastDueBusinessInvoices(
          res.data?.filter(
            (x) =>
              moment().diff(
                moment.utc(x.dueDate || x.current_billing_cycle_start),
                "hours"
              ) > 24 && !x.deleted
          )
        );
      } else {
        setPastDueBusinessInvoices([]);
      }
      if (res2?.success) {
        setPastDueUserInvoices(
          res2.data?.data?.filter(
            (x) =>
              (x.dueDate
                ? moment().diff(moment.utc(x.dueDate), "hours") > 24
                : x.type === "onetime"
                ? moment.utc(x.createdAt).add(28, "days").isBefore(moment())
                : moment().diff(
                    moment.utc(x.current_billing_cycle_start),
                    "hours"
                  ) > 24) && !x.deleted
          )
        );
      } else {
        setPastDueUserInvoices([]);
      }
      return { ...res, status: true };
    } catch (e) {
      setPastDueBusinessInvoices([]);
      setPastDueUserInvoices([]);
      return { status: false };
    }
  };

  const getCustomReports = async () => {
    const res = await callApi(`/protected/user/${user.id}/customreports`);
    if (res?.status) {
      setCustomReports(res.data);
    }
    return res;
  };

  const getPivotReports = async () => {
    const res = await callApi(`/protected/user/${user.id}/pivotreports`);
    if (res?.status) {
      setPivotReports(res.data);
    }
    return res;
  };

  const getAllLocationCampaigns = async () => {
    const res = await callApi(`/protected/user/${user.id}/campaign/all`);
    if (res?.status) {
      setAllLocationCampaigns(res.data);
    }
    return res;
  };
  
   const getWeekDays = (basicObjects,bizhours) => {
      const defaultHours = find(bizhours || [], {
        day: "default",
      });
      return map(basicObjects, (item) => {
        const dayHours = find(bizhours, { day: item.day }) ||
          defaultHours || { start: "08:00", end: "20:00", closed: false };
        return extend(item, pick(dayHours, ["start", "end", "closed"]));
      });
    };
  const getBusinessHours = async (basicObjects) => {
    try {
      const res = await callApi(
        `/protected/business/${
          selectedBusiness?.id
        }/iorequest?dest=${encodeURIComponent(
          `business/:BID:/network/:NID:/businesshours`
        )}`
      );
      if (res && res.status === true && res.data) {
        const bizHours = parseJSON(res.data , true) || {};
        if (bizHours.enabled && bizHours.hours.length) {
          setLocalHours({
            enabled: bizHours.enabled,
            hours: getWeekDays(basicObjects,bizHours.hours)
          });
          setEnforceEnable(bizHours.enabled);
        } else {
          setEnforceEnable(false);
          setLocalHours({
            enabled: false,
            hours: getWeekDays(basicObjects,bizHours.hours)

          });
        }
      }else{
         const bizHours = parseJSON(selectedBusiness?.business?.office_hours , true) || {};
        if (bizHours.enabled && bizHours.hours.length) {
          setLocalHours({
            enabled: bizHours.enabled,
            hours: getWeekDays(basicObjects,bizHours.hours)
          });
          setEnforceEnable(bizHours.enabled);
        } else {
          setEnforceEnable(false);
          setLocalHours({
            enabled: false,
            hours: getWeekDays(basicObjects,bizHours.hours)

          });
        }
      }
    } catch (e) {
      console.error("Error on gettingbusiness hours",e.message)
     
    }
  };

  const updateAllLocationCampaigns = (bizs, data) => {
    setAllLocationCampaigns([
      ...(allLocationCampaigns || []),
      ...(bizs?.map((biz) => ({
        business_id: biz?.id,
        network_id: biz?.network_id,
        ...data,
      })) || []),
    ]);
  };

  const getAllLocServices = async () => {
    const loc = businessLocations.map((el) => el.id);
    const params = (loc && loc.length && { loc: btoa(loc.join(",")) }) || {
      loc: btoa(selectedBusiness.id),
    };
    params.hidden = 1;
    if (loc.length > 1) {
      const res = await callApi(
        `/protected/business/${selectedBusiness.id}/allservices`,
        "GET",
        null,
        null,
        params
      );

      if (res && res.status === true) {
        setBusinessAllLocationServices(res.data);
      }
    } else if (businessAllServices)
      setBusinessAllLocationServices(businessAllServices);
    else {
      const res = await callApi(
        `/protected/business/${selectedBusiness.id}/getservices`
      );
      if (res && res.status === true) {
        setBusinessAllLocationServices(formatServiceCategories(res.data));
      }
    }
  };

  const getBusinessTablePreference = async (tableId) => {
    runWithGuard(async () => {
      const res = await callApi(
        `/protected/business/${selectedBusiness?.id}/tablesettings/${tableId}/get`
      );
      if (res && res.status === true) {
        setBusinessTablePreference({
          ...businessTablePreference,
          [tableId]: res.data,
        });
        return res.data;
      }
      toast.error(
        (res && res.message) || "Failed to fetch business table settings!"
      );
      return null;
    });
  };

  const updateBusinessTablePreference = async (tableId, data) => {
    const res = await callApi(
      `/protected/business/${selectedBusiness.id}/tablesettings/${tableId}/update`,
      "POST",
      data
    );
    if (res && res.status === true) {
      setBusinessTablePreference({
        ...businessTablePreference,
        [tableId]: res.data,
      });
      return;
      // toast.success("Updated to fetch business table settings!");
    }
    toast.error(res.message || "Failed to fetch business table settings!");
  };

  const payrollInfoSettingDefault = [
    {
      id: "payPeriod",
      visible: true,
    },
    {
      id: "salaryPerPayPeriod",
      visible: true,
    },
    {
      id: "hourlyRate",
      visible: true,
    },
    {
      id: "serviceCommissionType",
      visible: false,
    },
    {
      id: "serviceCommissionRate",
      visible: false,
    },
    {
      id: "retailCommissionType",
      visible: false,
    },
    {
      id: "retailCommissionRate",
      visible: false,
    },
    {
      id: "prepaidCommissionType",
      visible: false,
    },
    {
      id: "prepaidCommissionRate",
      visible: false,
    },
    {
      id: "minSalesThreshold",
      visible: false,
    },
    {
      id: "commissionThresholdType",
      visible: false,
    },
    {
      id: "deductionBasis",
      visible: false,
    },
    {
      id: "deductionType",
      visible: false,
    },
    {
      id: "deduction",
      visible: false,
    },
    {
      id: "commissionModel",
      visible: true,
    },
    {
      id: "payrollLogic",
      visible: true,
    },
  ];

  const formatPayrollInfo = (data) => {
    const settings = [];
    data?.settings?.forEach((x) => {
      settings.push({
        ...x,
        visible:
          x.visible ??
          payrollInfoSettingDefault.find((el) => el.id === x.id)?.visible,
      });
    });
    payrollInfoSettingDefault.forEach((x) => {
      if (!settings?.find((el) => el.id === x.id)) {
        settings.push(x);
      }
    });
    return { ...data, settings };
  };

  // get payroll info for payroll section.
  const getBusinessPayrollData = async () => {
    setBusinessLoading(true);
    runWithGuard(async () => {
      const res = await callApi(
        `/protected/business/${selectedBusiness.id}/payrollinfo/get`
      );
      if (res && res.status === true) {
        setBusinessPayrollInfo(formatPayrollInfo(res.data));
        setBusinessLoading(false);
      } else {
        toast.error(res?.message || "Failed to fetch payroll detail!");
        setBusinessLoading(false);
      }
    });
  };

  // update payroll info
  const updateBusinessPayrollInfo = async (
    settings,
    payrollHourSettings,
    lastPayoutStartDate
  ) => {
    const res = await callApi(
      `/protected/business/${selectedBusiness.id}/payrollinfo/update`,
      "POST",
      {
        settings,
        payrollHourSettings: payrollHourSettings || null,
        lastPayoutStartDate: lastPayoutStartDate || undefined,
      }
    );
    if (res) {
      toast.success("Business Payroll Updated ");
      setBusinessPayrollInfo(res.data);
      updateCurrentBusiness({
        ...selectedBusiness,
        info: {
          ...selectedBusiness.info,
          payInfo: res.data,
        },
      });
    } else {
      toast.success(res.message || "Failed to update business payroll ");
    }
  };

  const aggregatePayrollInfo = ({ hours, sales, tickets }) => {
    const employees = _.uniq(
      hours.map((x) => x.employee_id).concat(sales.map((x) => x.employee_id))
    );

    const sumFunction = (array, key) => _.sumBy(array, (x) => +x[key] || 0);
    const salesSumFunction = (array, key, type) =>
      _.sumBy(
        array.filter((x) => x.type === type),
        (x) => parseInt(x[key], 10)
      );

    const salesAggregateObject = (array, type) => {
      const obj = {};
      const aliasType =
        type === "retail" ? "product" : type === "prepaid" ? "gc" : null;
      obj[`${type}_quantity`] = array
        .filter((x) => x.type === type)
        .map((x) => +x.quantity || 0)
        .reduce((a, b) => a + b, 0);
      obj[`${type}_sales_after_discount`] = salesSumFunction(
        array,
        "sales_after_discount",
        type
      );
      obj[`${type}_sales_before_discount`] = salesSumFunction(
        array,
        "sales_before_discount",
        type
      );
      obj[`${type}_sales_for_commission`] = salesSumFunction(
        array,
        "sales_after_discount",
        type
      );
      if (aliasType) {
        obj[`${aliasType}_quantity`] = obj[`${type}_quantity`];
        obj[`${aliasType}_sales_after_discount`] =
          obj[`${type}_sales_after_discount`];
        obj[`${aliasType}_sales_before_discount`] =
          obj[`${type}_sales_before_discount`];
        obj[`${aliasType}_sales_for_commission`] =
          obj[`${type}_sales_for_commission`];
      }
      return obj;
    };

    return employees.map((el) => {
      const filteredHours = hours.filter((x) => x.employee_id === el);
      const filteredSales = sales.filter((x) => x.employee_id === el);
      const filteredTickets =
        tickets?.filter((x) => x.employee_id === el) || [];
      const hoursTotal = sumFunction(filteredHours, "hours");
      const breakHours = sumFunction(filteredHours, "breakHours");
      const hoursAfterBreak = sumFunction(filteredHours, "hoursAfterBreak");
      const ticketsTotal = sumFunction(filteredTickets, "tickets");
      const totalSalesAfterDiscount = sumFunction(
        filteredSales,
        "sales_after_discount"
      );
      const totalSalesBeforeDiscount = sumFunction(
        filteredSales,
        "sales_before_discount"
      );
      const tip = sumFunction(filteredSales, "tip");

      return {
        employee_id: el,
        salesArray: filteredSales,
        hours: hoursTotal,
        tickets: ticketsTotal,
        breakHours,
        hoursAfterBreak,
        total_sales_after_discount: totalSalesAfterDiscount,
        total_sales_before_discount: totalSalesBeforeDiscount,
        tip,
        ...salesAggregateObject(filteredSales, "service"),
        ...salesAggregateObject(filteredSales, "retail"),
        ...salesAggregateObject(filteredSales, "prepaid"),
      };
    });
  };

  // get payroll data info for payroll calculator
  const getBusinessPayrollInfoData = async (period) => {
    setBusinessLoading(true);
    runWithGuard(async () => {
      const res = await callApi(
        `/protected/business/${selectedBusiness.id}/payrolldata/withservicedetail?start=${period.periodStart}&end=${period.periodEnd}`
      );
      if (res && res.status === true) {
        setBusinessPayrollInfoData(aggregatePayrollInfo(res.data));
        setBusinessPayrollWithServiceDetail(res.data);
        setBusinessLoading(false);
      } else {
        toast.error(res?.message || "Failed to fetch payroll data!");
        setBusinessLoading(false);
      }
    });
  };

  // Legacy API function for period reports
  const getBusinessPeriodReport = async (period, type) => {
    setBusinessLoading(true);
    runWithGuard(async () => {
      const res = await callApi(
        `/protected/business/${selectedBusiness.id}/periodreport/${period.periodStart}/${period.periodEnd}`,
        "GET",
        null,
        null,
        { detail: false, type: type || undefined }
        // `/protected/business/3/periodreport/2021-05-01/2021-05-31?detail=false`
      );
      if (res && res.status === true) {
        setBusinessPeriodReport(res.data.perioddata);

        setBusinessLoading(false);
      } else {
        toast.error(res.message || "Failed to fetch reports!");
        setBusinessLoading(false);
      }
    });
  };

  //  New api for the period report data from cubejs
  const getCubeBusinessPeriodReport = async (period, type, uid) => {
  setCubeBusinessLoading(true);
  runWithGuard(async () => {
    const res = await callApiIO(
      `/protected/business/${
        selectedBusiness?.id
      }/iorequest?dest=${encodeURIComponent(
        `business/:BID:/user/:UID:/periodreport/${period.periodStart}/${period.periodEnd}?type=${type}${uid ? `&uid=${uid}` : ''}`
      )}`
    );
    if (!selectedBusiness?.id) {
      toast.error("No selected business available.");
      return;}
    if (res && res.status === true && res.data?.perioddata) {
      setCubeBusinessPeriodReport(res.data.perioddata);
      setCubeGranularity(res.data.granularity || "day");
      setCubeBusinessLoading(false);
    } else {
      toast.error(res?.message || "Failed to fetch reports!");
      setCubeBusinessLoading(false);
    }
  });
};

  const getStaffVisitReport = async (period) => {
    setBusinessLoading(true);
    runWithGuard(async () => {
      const res = await callApi(
        `/protected/business/${selectedBusiness.id}/staffvisitdata`,
        "GET",
        null,
        null,
        {
          start: period.periodStart,
          end: period.periodEnd,
        }
      );
      if (res && res?.status === true) {
        setStaffVisitReport(res.data.salesbyvisit);
        setBusinessLoading(false);
      } else {
        toast.error(res?.message || "Failed to fetch report!");
        setBusinessLoading(false);
      }
    });
  };

  const getBusinessInfo = async () => {
    setBusinessLoading(true);
    runWithGuard(async () => {
      const res = await callApi(
        `/protected/user/${user.id}/business/${selectedBusiness.id}/detail`,
        "GET"
      );
      if (res && res.status === true) {
        setBusinessInfo(res.data);
        setBusinessLoading(false);
      } else {
        toast.error(res.message || "Failed to fetch info!");
        setBusinessLoading(false);
      }
    });
  };

  const getBusinessInventory = async () => {
    setBusinessLoading(true);
    runWithGuard(async () => {
      const res = await callApi(
        `/protected/business/${selectedBusiness.id}/getproducts`,
        "GET"
      );
      if (res && res.status === true) {
        const res2 = await callApi(
          `/protected/business/${selectedBusiness.id}/vendor/get`
        );
        let { productcategories } = res.data;
        if (res2 && res2?.status === true) {
          const temp = res2.data?.flatMap?.((vendor) =>
            vendor.products?.map((prod) => ({
              ...prod,
              vendor_id: vendor.id,
              vendor_name: vendor.name,
            }))
          );
          productcategories = productcategories?.map((x) => ({
            ...x,
            products: x.products?.map((p) => {
              const found = temp?.find((el) => el.id === p.id);
              return {
                ...p,
                ...(found
                  ? {
                      vendor_id: found.vendor_id,
                      vendor_name: found.vendor_name,
                    }
                  : {}),
              };
            }),
          }));
        }

        setBusinessInventory(formatProductCategories(productcategories));
        setUnfilteredProducts(productcategories);
        setBusinessLoading(false);
      } else {
        toast.error(res?.message || "Failed to fetch products!");
        setBusinessLoading(false);
      }
    });
  };

  const getBusinessServices = async () => {
    setBusinessLoading(true);
    const res = await callApi(
      `/protected/business/${selectedBusiness.id}/getservices`
    );
    if (res && res.status === true) {
      const prepaid = flatten(
        map(
          filter(formatServiceCategories(res.data), (cat) => cat.giftcard > 0),
          "services"
        )
      );
      const prepaids = flatten(
        filter(formatServiceCategories(res.data), (cat) => cat.giftcard > 0)
      );
      const services = flatten(
        filter(formatServiceCategories(res.data), (cat) => cat.giftcard === 0)
      );
      // const memberships = filter(
      //   prepaid,
      //   (pre) => pre.attributes?.club || pre.clubmembership
      // );
      setBusinessPrepaid(prepaid);
      setBusinessPrepaidCata(prepaids);
      setBusinessServices(services);
      // setBusinessMemberships(memberships);
      setBusinessAllServices(formatServiceCategories(res.data));
      setAllFilteredServices(formatServiceCategoriesAll(res.data));
      setUnfilteredServices(res.data);
      setBusinessLoading(false);
    } else {
      toast.error(res ? res.message : "Something went wrong");
      setBusinessLoading(false);
    }
  };

  const getBusinessProducts = async () => {
    setBusinessLoading(true);
    const res = await callApi(
      `/protected/business/${selectedBusiness.id}/getproducts`
    );
    setbusinessAllProducts(res?.data?.productcategories);
    if (res && res.status === true) {
      const products = flatten(
        res?.data?.productcategories.map((item) => {
          return item.products;
        })
      );
      setBusinessProducts(products);
      setBusinessLoading(false);
    } else {
      toast.error(res ? res.message : "Something went wrong in Products");
      setBusinessLoading(false);
    }
  };

  const getSettingsForAnotherBusiness = async (bid) => {
    const res = await callApi(`/protected/business/${bid}/bizsettings/get`);
    return res;
  };

  const getServicesForAnotherBusiness = async (bid) => {
    const res = await callApi(`/protected/business/${bid}/getservices`);
    return res;
  };

  const getBusinessServiceOnly = async () => {
    const res = await callApi(
      `/protected/business/${selectedBusiness.id}/getservices`
    );
    if (res && res.status === true) {
      return formatServiceCategories(res?.data);
    }
    toast.error(res ? res.message : "Something went wrong");
    return null;
  };

  const businessServiceUpdate = (data) => {
    if (!businessAllServices) return getBusinessServices();
    const flattenedServices = businessAllServices.flatMap((el) => el.services);
    const found = flattenedServices?.find((x) => x.id === data?.id);
    if (!found) return null;
    let allServices;
    if (found?.category_id === +data.category_id) {
      allServices = businessAllServices?.map((x) => {
        if (x.id !== data.category_id) {
          return x;
        }
        return {
          ...x,
          services: x.services?.map((el) => {
            if (el.id === data.id) return { ...el, ...data };
            return el;
          }),
        };
      });
    } else {
      allServices = businessAllServices?.map((x) => {
        if (x.id !== +data.category_id && x.id !== found.category_id) {
          return x;
        }
        if (x.id === found.category_id) {
          return {
            ...x,
            services: x.services?.filter((el) => el.id !== data.id),
          };
        }
        return {
          ...x,
          services: [...(x.services || []), data],
        };
      });
    }
    const prepaid = flatten(
      map(
        filter(allServices, (cat) => cat.giftcard > 0),
        "services"
      )
    );
    const services = flatten(filter(allServices, (cat) => cat.giftcard === 0));
    setBusinessPrepaid(prepaid);
    setBusinessServices(services);
    setBusinessAllServices(allServices);
    return null;
  };

  const businessCategoryUpdate = (data) => {
    if (!businessAllServices) return getBusinessServices();
    const allServices = formatServiceCategories(
      businessAllServices?.map((x) => {
        if (x.id !== data.id) {
          return x;
        }
        return {
          ...x,
          ...data,
        };
      })
    );
    const prepaid = flatten(
      map(
        filter(allServices, (cat) => cat.giftcard > 0),
        "services"
      )
    );
    const services = flatten(filter(allServices, (cat) => cat.giftcard === 0));
    setBusinessPrepaid(prepaid);
    setBusinessServices(services);
    setBusinessAllServices(allServices);
    setBusinessAllLocationServices(undefined);
    return null;
  };

  const businessServiceAdd = (data) => {
    if (!businessAllServices) return getBusinessServices();
    const category = businessAllServices.find((x) => x.id === data.category_id);
    if (!category) return getBusinessServices();

    const allServices = businessAllServices?.map((x) => {
      if (x.id !== data.category_id) {
        return x;
      }
      return {
        ...x,
        services: [...x.services, data],
      };
    });

    const prepaid = flatten(
      map(
        filter(allServices, (cat) => cat.giftcard > 0),
        "services"
      )
    );
    const services = flatten(filter(allServices, (cat) => cat.giftcard === 0));
    setBusinessPrepaid(prepaid);
    setBusinessServices(services);
    setBusinessAllServices(allServices);
    setBusinessAllLocationServices(undefined);
    return null;
  };

  const businessCategoryAdd = (data) => {
    if (!businessAllServices) return getBusinessServices();

    const allServices = [...businessAllServices, { services: [], ...data }];

    const prepaid = flatten(
      map(
        filter(allServices, (cat) => cat.giftcard > 0),
        "services"
      )
    );
    const services = flatten(filter(allServices, (cat) => cat.giftcard === 0));
    setBusinessPrepaid(prepaid);
    setBusinessServices(services);
    setBusinessAllServices(allServices);
    setBusinessAllLocationServices(undefined);
    return null;
  };

  const businessCategoryDelete = (id) => {
    if (!businessAllServices) return getBusinessServices();

    const allServices = businessAllServices?.filter((x) => x.id !== id);

    const prepaid = flatten(
      map(
        filter(allServices, (cat) => cat.giftcard > 0),
        "services"
      )
    );
    const services = flatten(filter(allServices, (cat) => cat.giftcard === 0));
    setBusinessPrepaid(prepaid);
    setBusinessServices(services);
    setBusinessAllServices(allServices);
    setBusinessAllLocationServices(undefined);
    return null;
  };

  const businessServiceDelete = (id) => {
    if (!businessAllServices) return getBusinessServices();

    const allServices = businessAllServices?.map((cat) => ({
      ...cat,
      services: cat?.services?.filter((ser) => ser.id !== id),
    }));

    const prepaid = flatten(
      map(
        filter(allServices, (cat) => cat.giftcard > 0),
        "services"
      )
    );
    const services = flatten(filter(allServices, (cat) => cat.giftcard === 0));
    setBusinessPrepaid(prepaid);
    setBusinessServices(services);
    setBusinessAllServices(allServices);
    setBusinessAllLocationServices(undefined);
    return null;
  };

  const convertServicesTaxable = (id, taxable) => {
    if (!businessAllServices) return getBusinessServices();

    const allServices = businessAllServices?.map((cat) => {
      if (cat.id !== id) return cat;
      return {
        ...cat,
        services: cat?.services?.map((x) => ({
          ...x,
          attributes: { ...x.attributes, taxable },
        })),
      };
    });

    const prepaid = flatten(
      map(
        filter(allServices, (cat) => cat.giftcard > 0),
        "services"
      )
    );
    const services = flatten(filter(allServices, (cat) => cat.giftcard === 0));
    setBusinessPrepaid(prepaid);
    setBusinessServices(services);
    setBusinessAllServices(allServices);
    return null;
  };

  const getMemberships = async (disableLoading) => {
    if (!disableLoading) setBusinessLoading(true);
    runWithGuard(async () => {
      const res = await callApi(
        `/protected/business/${selectedBusiness?.id}/clubmemberships`
      );
      if (res && res.status === true) {
        setBusinessMemberships(res.data);
        if (isArray(res.data) && res.data.length) {
          setMembershipCategoryID(res.data[res.data.length - 1].category_id);
        }
        if (!disableLoading) setBusinessLoading(false);
      } else {
        toast.error(res ? res.message : "Something went wrong");
        if (!disableLoading) setBusinessLoading(false);
      }
    });
  };

  const getBusinessSettings = async (tableID, config) => {
    setBusinessLoading(true);
    runWithGuard(async () => {
      const res = await callApi(
        `/protected/business/${selectedBusiness?.id}/tablesettings/${tableID}/update`
      );
      if (res && res.status) {
        toast.success("Business setting fetch");
        setBusinessSettings(config);
        setBusinessLoading(false);
      } else {
        toast.error(res.message);
        setBusinessLoading(false);
      }
    });
  };

  const fetchTableSettings = async (tableId) => {
    const res = await callApi(
      `/protected/business/${selectedBusiness?.id}/tablesettings/${tableId}/get`
    );
    return res;
  };

  const changeTableSettings = async (config, tableID, id) => {
    const res = await callApi(
      `/protected/business/${selectedBusiness?.id}/tablesettings/${tableID}/update`,
      "POST",
      {
        settings: {
          title: tableID,
          configuration: config,
          id,
        },
      }
    );
    return res;
  };

  const fetchVisitReportSettings = async () => {
    const res = await fetchTableSettings(visitReportTableId);
    if (res?.status) {
      setVisitReportTableSettings(res?.data);
    }
    return res;
  };

  const updateVisitReportSettings = (config) =>
    changeTableSettings(
      config,
      visitReportTableId,
      visitReportTableSettings?.id
    );

  const initBusinessEligibleLocations = () => {
    setBusinessEligibleLocations(businessLocations?.map((el) => el.id) || []);
  };

  const initGZPAY = (w) => {
    const { webcode, name } = selectedBusiness?.info || {};
    if (w && w.gzPAYx) {
      w.gzPAYx.init(`BIZ-${webcode}`, name);
    }
  };

  const getTaskResourceMap = async () => {
    const res = await callApi(
      `/protected/business/${selectedBusiness?.id}/appointments/taskresourcemap`
    );
    if (res?.status) setTaskResourceMap(res.data);
  };

  const getServiceKinds = async () => {
    const res = await callApi(
      `/protected/business/${selectedBusiness?.id}/allkinds`
    );
    if (res?.status) {
      setServiceKinds(res.data);
    } else {
      setServiceKinds([]);
    }
  };

  const suspendAccount = async (date, bid) => {
    const res = await callApi(
      `/protected/admin/${bid || selectedBusiness?.id}/suspension/update`,
      "POST",
      { date }
    );
    if (res?.status) {
      let newData;
      const newDate = res.data.suspensionDate;
      if (!newDate) {
        newData = {
          isSuspended: false,
          willBeSuspended: false,
          suspended_after: newDate,
        };
      } else if (moment.utc(newDate).isAfter(moment())) {
        newData = {
          isSuspended: false,
          willBeSuspended: true,
          suspended_after: newDate,
        };
      } else {
        newData = {
          isSuspended: true,
          willBeSuspended: false,
          suspended_after: newDate,
        };
      }
      updateCurrentBusiness({
        ...selectedBusiness,
        business: { ...selectedBusiness?.business, ...newData },
        info: { ...selectedBusiness?.info, ...newData },
      });
    }
    return res;
  };

  useEffect(() => {
    setBusinessAllLocationServices(undefined);
    setBusinessServices(undefined);
    setBusinessPrepaid(undefined);
    setBusinessInventory(undefined);
    setUnfilteredProducts(undefined);
    setBusinessAllServices(undefined);
    setUnfilteredServices(undefined);
    setBusinessLocations(
      business?.filter(
        (el) => el.network_id === selectedBusiness?.business?.network_id
      )
    );
    // setCustomerSearchHistory(undefined);
    setTaskResourceMap(null);
    setServiceKinds(null);
    if (selectedBusiness?.id) {
      getBusinessUnpaidInvoices();
      fetchMCPSamplequestions();
    }
    const setupDb = async () => {
      setDbInstance(null);
      const _dbInstance = await DuckDb.instantiate();
      setDbInstance(_dbInstance);
      // eslint-disable-next-line no-console
      console.log("DB Instance Created");
    };
    setupDb();
  }, [selectedBusiness?.id]);

  useEffect(() => {
    initBusinessEligibleLocations();
    // if (businessLocations.length) getAllLocServices();
  }, [businessLocations]);

  const updateUscCache = (sid, uscId) => {
    const sids = Array.isArray(sid) ? sid : [sid];

    if (!sid || !uscId) return;

    const allServices = businessAllServices.map((x) => ({
      ...x,
      services: x?.services?.map((el) => {
        if (sids?.includes(el.id))
          return {
            ...el,
            usc_id: uscId,
          };
        return el;
      }),
    }));

    const prepaid = flatten(
      map(
        filter(allServices, (cat) => cat.giftcard > 0),
        "services"
      )
    );
    const services = flatten(filter(allServices, (cat) => cat.giftcard === 0));
    setBusinessPrepaid(prepaid);
    setBusinessServices(services);

    setBusinessAllServices(allServices);

    setBusinessAllLocationServices(
      businessAllLocationServices?.map((x) => ({
        ...x,
        services: x.services?.map((el) => {
          if (sids?.includes(el.id))
            return {
              ...el,
              usc_id: uscId,
            };
          return el;
        }),
      }))
    );
  };

  const checkLoggedInStatus = async () => {
    await callApi(`/protected/user/${user?.id}/checkstatus`);
  };

  const getBusinessSetting = async (key, json) => {
    const res = await callApi(
      `/protected/business/${
        selectedBusiness?.id
      }/iorequest?dest=${encodeURIComponent(
        `bizsetting/business/:BID:/get?key=${key}${json ? `&json=1` : ""}`
      )}`,
      "GET"
    );
    return res;
  };

  const updateBusinessSetting = async (key, value, json) => {
    const res = await callApi(
      `/protected/business/${selectedBusiness?.id}/iorequest?dest=bizsetting/business/:BID:/update`,
      "POST",
      { key, value, json }
    );
    return res;
  };

  useEffect(() => {
    setCustomReports(undefined);
    setPivotReports(undefined);
    setAllLocationCampaigns(undefined);
  }, [user?.id]);

  const handleLogOut = (event) => {
    if (event?.data?.method === "loggedOut") {
      if (window.location.pathname?.substring(0, 8) === "/apikey/") {
        return;
      }
      logOut();
    }
  };

  useEffect(() => {
    window.addEventListener("message", handleLogOut);

    // cleanup this component
    return () => {
      window.removeEventListener("message", handleLogOut);
    };
  }, []);

  useEffect(() => {
    window.addEventListener("online", checkLoggedInStatus);

    // cleanup this component
    return () => {
      window.removeEventListener("online", checkLoggedInStatus);
    };
  }, []);

  return {
    businessPayrollInfo,
    businessPayrollInfoData,
    businessPayrollWithServiceDetail,
    businessPeriodReport,
    staffVisitReport,
    businessInfo,
    businessInventory,
    unfilteredProducts,
    businessServices,
    businessMemberships,
    businessPrepaid,
    businessPrepaidCata,
    businessTablePreference,
    unfilteredServices,
    businessAllServices,
    allFilteredServices,
    businessAllLocationServices,
    businessLocations,
    businessSettings,
    businessLoading,
    businessEligibleLocations,
    membershipCategoryID,
    // customerSearchHistory,
    customerSearchParams,
    visitReportTableSettings,
    customReports,
    pivotReports,
    allLocationCampaigns,
    taskResourceMap,
    serviceKinds,
    pastDueUserInvoices,
    pastDueBusinessInvoices,

    cubeBusinessPeriodReport,
    cubeBusinessLoading,
    cubeGranularity,
    sampleQuestions,

    // functions
    setServiceKinds,
    getServiceKinds,
    getAllLocationCampaigns,
    updateAllLocationCampaigns,
    getCustomReports,
    getPivotReports,
    businessServiceAdd,
    businessServiceUpdate,
    businessServiceDelete,
    businessCategoryAdd,
    businessCategoryUpdate,
    businessCategoryDelete,
    convertServicesTaxable,
    setBusinessEligibleLocations,
    setBusinessAllLocationServices,
    setBusinessMemberships,
    initBusinessEligibleLocations,
    getBusinessPayrollData,
    getBusinessPeriodReport, // Legacy API
    getStaffVisitReport,
    updateBusinessPayrollInfo,
    getBusinessInfo,
    getBusinessInventory,
    getBusinessServices,
    getMemberships,
    getAllLocServices,
    getBusinessPayrollInfoData,
    getBusinessTablePreference,
    getBusinessSettings,
    updateBusinessTablePreference,
    setMembershipCategoryID,
    setCustomerSearchParams,
    initGZPAY,
    fetchVisitReportSettings,
    updateVisitReportSettings,
    updateUscCache,
    getBusinessServiceOnly,
    getServicesForAnotherBusiness,
    getSettingsForAnotherBusiness,
    getTaskResourceMap,
    suspendAccount,
    checkLoggedInStatus,
    getBusinessSetting,
    updateBusinessSetting,
    dbInstance,
    getBusinessProducts,
    businessAllProducts,
    businessProducts,
    getBusinessHours,
    enforceEnable,
    setEnforceEnable,
    localHours,
    setLocalHours,
    getCubeBusinessPeriodReport,
  };
};